import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import validator from "validator";
import FormError from "../../../FormError";
import { addEmailRecipient, removeEmailRecipient } from '../../../redux/FeedbackRedux';



class EmailRecipients extends React.Component {
    constructor(props) {
        super(props);
        this.state = { email_address: "", name: "" };

        this.handleAddEmailRecipient = this.handleAddEmailRecipient.bind(this);
    }

    handleAddEmailRecipient(event) {
        var email = this.state.email_address;
        if (!email || !validator.isEmail(email)) {
            this.setState({ email_error: __("Please enter a valid email address") });
            return;
        }

        if (
            this.props.email_recipients
                .map((item, key) => item.value)
                .includes(this.state.email_address)
        ) {
            this.setState({
                email_error: __("This email address is already in the list")
            });
            return;
        }

        this.props.dispatch(addEmailRecipient(this.state));

        this.setState({ email_address: "", name: "", email_error: false });
    }

    handleRemoveEmailRecipient(uuid, event) {
        event.preventDefault();
        this.props.dispatch(removeEmailRecipient({ "uuid": uuid }));
    }

    render() {
        return (
            <div className="">
                <div className="pb-2">
                    <h5><b>{__('Emails')}:</b></h5>
                    <p className="">
                        {__("Non-registered users can receive an email whenever Feedback is submitted for this business. The email will include the customer's information along with a link to view the Feedback. This function is primarily to be used by organizations that have more than one location and corporate employees want to be notified of every Feedback sent")}
                    </p>
                    <div className='d-flex align-items-end mb-2 filter-bar-wrapper'>
                        <div className="row w-100 mt-2">
                            <div className="col-sm-6 px-3 mt-2">
                                <div className="input-group feedback-form-control mt-2">
                                    <input
                                        placeholder={__('Email Address')}
                                        type="email"
                                        className="form-control input pl-2"
                                        name="recipient_email"
                                        value={this.state.email_address}
                                        onChange={event =>
                                            this.setState({ email_address: event.target.value })
                                        }
                                        onKeyPress={e => { if (e.key === "Enter") { e.preventDefault(); this.handleAddEmailRecipient(); } }}
                                    ></input>
                                </div>
                                <FormError error_message={this.state.email_error}></FormError>
                            </div>

                            <div className="col-sm-6 px-3 mt-2">
                                <div className="input-group feedback-form-control mt-2">
                                    <input
                                        placeholder={__("Recipient First and Last Name")}
                                        type="text"
                                        className="form-control input pl-2"
                                        name="name"
                                        value={this.state.name}
                                        onChange={event =>
                                            this.setState({ name: event.target.value })
                                        }
                                        onKeyPress={e => { if (e.key === "Enter") { e.preventDefault(); this.handleAddEmailRecipient(); } }}
                                    ></input>
                                </div>

                            </div>
                        </div>
                        <div className="text-right ml-2 mt-2">
                            <a
                                className="btn btn-sm btn-primary text-white text-nowrap"
                                onClick={this.handleAddEmailRecipient}
                            >
                                <i className="fas fa-inbox-in mr-1"></i> {__('Add Email Address To List')}
                            </a>
                        </div>
                    </div>
                    <h5>{__('Email Address List: (click on a contact to remove them from the list)')}</h5>

                    <div className="row">
                        <div className="col-sm-12 d-flex">
                            {this.props.email_recipients.map((item, key) => (
                                <div className="d-inline-block mr-2" key={item.uuid}>
                                    <button
                                        href=""
                                        className="btn btn-secondary btn-sm"
                                        onClick={this.handleRemoveEmailRecipient.bind(
                                            this,
                                            item.uuid
                                        )}
                                    >
                                        {item.value}{" "}
                                        {item.description ? "(" + item.description + ")" : ""}
                                    </button>
                                </div>

                            ))}

                            {this.props.email_recipients.length == 0 ? (
                                <div>{__('Empty')}</div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                </div>
                <input
                    type="hidden"
                    name="email_recipients"
                    value={JSON.stringify(this.props.email_recipients)}
                ></input>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        email_recipients: state.email_recipients
    }
}

export default connect(mapStateToProps)(EmailRecipients)
